import styled from 'styled-components';

const PagesList = styled.ul`
  margin: 50px 0 0 0;
  padding: 0;
  display: flex;
  justify-content: space-around;
  list-style: none;
`;
export default PagesList;
